import Phaser from 'phaser';
import {gsap} from 'gsap';


export default class RecFin{

    constructor(){
        this.scene =  GAME_REF.scene;
        this.emitter = new Phaser.Events.EventEmitter();

        this.$self = null;
        this.$btnRetry = null;
        this.$btnOk = null;
        this.$btnPlay = null;
        this.$iframe = null;
        
        this.isInited = false;
        this.sound = GAME_REF.obj.sound;

        this.timer = null;
        this.attTimer1 = null;
        this.attTimer2 = null;
        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }


    render(){
        GAME_REF.obj.question.ques.setVisible(false);

        const idx = Math.floor(Math.random() * 3) + 1;
        this.$iframe.setAttribute('src', `./movie/recmovie${idx}.html`);

        if(!this.isInited) this._na1st();
        else this._na2nd();

        this.$self.classList.add('-active');

        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    hide(){
        if(this.playtimer) clearTimeout(this.playtimer);
        GAME_REF.obj.question.ques.setVisible(true);

        this.$iframe.setAttribute('src', '');
        this.$iframe.classList.remove('-active');

        this.$btnPlay.classList.remove('-playing');
        this.$btnPlay.classList.remove('-progress');

        this.$self.classList.remove('-active');
        this.grapes.classList.remove('-active');

        if(this.timer) this.timer.kill();
        if(this.attTimer1) this.attTimer1.kill();
        if(this.attTimer2) this.attTimer2.kill();

        window.removeEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.removeEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    _init(){
        this.EVENT_REC_RETRY = 'rec_retry';
        this.EVENT_REC_OK = 'rec_ok';
        
        this.$self = document.querySelector('.js-recfin');
        this.$btnRetry = document.querySelector('.js-recfin__retry');
        this.$btnOk = document.querySelector('.js-recfin__ok');
        this.$btnPlay = document.querySelector('.js-recfin__play');
        this.$iframe = document.querySelector('.js-recfin__video');
        this.grapes = document.querySelector('.recfin__grapes');

        this._ui();
    }


    _ui(){

        this.$btnRetry.addEventListener('click', ()=>{
            this.sound.stopAll();
            this.hide();
            this.emitter.emit(this.EVENT_REC_RETRY);
        });

        this.$btnOk.addEventListener('click', ()=>{
            this.sound.stopAll();
            this.hide();
            this.emitter.emit(this.EVENT_REC_OK);
        });

        document.querySelector('.recfin__play__btn').addEventListener('click', ()=>{
            this.sound.stopAll();
            this._updateUI();
            this._setRecPlayMovie();
            
            this.timer = gsap.delayedCall(4, ()=>{
                this.timer = null;
                this._na2nd();
            });

            this.grapes.classList.remove('-active');

            this.emitter.emit(this.EVENT_REC_PLAY);
        });
    }

    _updateUI(){
        this.$btnPlay.classList.add('-playing');
        this.$btnPlay.classList.add('-progress');
        this.grapes.classList.add('-active');

        if(!this.isInited){
            this.$self.setAttribute('data-replay', '1');
            this.isInited = true;
        }
    }

    _setRecPlayMovie(){
        this.$iframe.contentWindow.player.playMovie();
        this.$iframe.classList.add('-active');

        gsap.set(this.$iframe, {opacity:0});
        gsap.to(this.$iframe, {duration:0.5, opacity:1, ease:'power2.out'});
    }


    // 動画のiframeページから呼び出す
    playProgressEnd(){

        gsap.to(this.$iframe, {duration:0.5, opacity:0, ease:'power2.out', onComplete:()=>{
            this.$iframe.classList.remove('-active');
        }});
    }

    _na1st(){
        this.sound.playSequence(['rec_na1', 'rec_na2']);
    }

    _na2nd(){
        this.sound.playSequence(['rec_na3', 'rec_na4'], ()=>{
            gsap.to(document.querySelector('.recfin__play__btn span'), {duration:0.2, scale:1.2, ease:'power2.out'});
            gsap.to(document.querySelector('.recfin__play__btn span'), {duration:0.2, delay:0.2, scale:1.0, ease:'power2.out'});
            this.$btnPlay.classList.remove('-playing');
            this.$btnPlay.classList.remove('-progress');
        });

        this.sound.setOnSequenceOneStart(key => {

            if(key === 'rec_na4'){
                gsap.killTweensOf(this.$btnOk.querySelector('span'));
                gsap.killTweensOf(this.$btnRetry.querySelector('span'));

                const $ok = this.$btnOk.querySelector('span');
                const $retry = this.$btnRetry.querySelector('span');

                this.attTimer1 = gsap.delayedCall(1.5, ()=>{
                    this.attTimer1 = null;
                    gsap.to($ok, {duration:0.2, scale:1.2, yoyo:true, repeat: 1, ease:'power2.out'});
                });

                this.attTimer2 = gsap.delayedCall(4.2, ()=>{
                    this.attTimer2 = null;
                    gsap.to($retry, {duration:0.2, scale:1.2, yoyo:true, repeat: 1, ease:'power2.out' });
                });
            }
        });
    }


    _pause(){
        if(this.timer) this.timer.pause();
        if(this.attTimer1) this.attTimer1.pause();
        if(this.attTimer2) this.attTimer2.pause();
    }

    _resume(){
        if(this.timer) this.timer.resume();
        if(this.attTimer1) this.attTimer1.resume();
        if(this.attTimer2) this.attTimer2.resume();
    }
}